import { useCallback, useEffect } from 'react';

export const useOutsideClickAndScroll = (ref, isTablet, isOpen, onClose) => {
  const handleClickOutside = useCallback(
    e => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    },
    [onClose],
  );

  const handleScroll = useCallback(() => {
    if (isTablet && isOpen) {
      onClose();
    }
  }, [isTablet, isOpen, onClose]);

  useEffect(() => {
    if (isTablet && isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('scroll', handleScroll);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleScroll);
    };
  }, [isTablet, isOpen, handleClickOutside, handleScroll]);
};
